import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * The trail of the active route, outermost first: the `data.breadcrumb` of every route on the first-child path (a string or
 * a list of them), each followed by the value its `data.breadcrumbResolve` names (the tenant hub resolves `tenantName`).
 * The entries are translation keys or plain text; `I18n.routeText` turns the keys into words.
 *
 * ONE definition for the two readers that must agree: the breadcrumb in the topbar (`AppBreadcrumb`) and the title of the
 * tab (`IdentityTitleStrategy`) — a tab named differently from the page it shows would be a defect.
 */
export function routeCrumbs(root: ActivatedRouteSnapshot): string[] {
    const crumbs: string[] = [];

    for (let route = root.firstChild; route; route = route.firstChild) {
        const breadcrumb = route.data['breadcrumb'];
        if (breadcrumb) {
            if (Array.isArray(breadcrumb)) {
                crumbs.push(...breadcrumb);
            } else {
                crumbs.push(breadcrumb);
            }
        }
        // A route may add a dynamic crumb from a resolver: `data.breadcrumbResolve` names the resolve key
        // (e.g. the tenant hub resolves `tenantName`), and the resolved string is pushed after the static crumb.
        const resolveKey = route.data['breadcrumbResolve'];
        if (resolveKey) {
            const resolved = route.data[resolveKey];
            if (resolved) {
                crumbs.push(resolved);
            }
        }
    }

    return crumbs;
}
